import React, { useState } from "react";
import Sidebar from "../Components/Sidebar";
import MainContent from "../Components/MainContent";
import Header from "../Components/Header";
import Offcanvasbar from "../Components/Offcanvasbar";

const AdminLayout = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const isShop = 'admin'

  return (
    <div className="d-flex mb-3 h-auto" id="wrapper">
      <Header isShop={false} />
      <Sidebar />
      <MainContent />
      {show ? (
        <div className="canvas">
          <Offcanvasbar
          // isShop={"admin"}
            show={show}
            handleClose={handleClose}
            setShow={setShow}
          />
        </div>
      ) : null}
    </div>
  );
};

export default AdminLayout;
